<template>
  <v-menu v-model="menuOpen" :close-on-content-click="false">
    <template v-slot:activator="{ props }">
      <v-text-field
          v-model="model"
          :class="localProps.readonly ? 'custom-readonly' : ''"
          :label="localProps.label"
          :rules="[localProps.required ? v => !!v || 'Bitte Zeit wählen!' : () => true]"
          :variant="useGlobalSetting().globalTextVariant"
          readonly
          :disabled="localProps.disabled"
          v-bind="props"
      ></v-text-field>
    </template>

    <v-time-picker
        v-if="!localProps.readonly"
        v-model="model"
        format="24hr"
    ></v-time-picker>
  </v-menu>
</template>

<script lang="ts" setup>
import {ref} from 'vue'
import {useGlobalSetting} from "@/lib/utils";

const menuOpen = ref(false)

const model = defineModel()

const localProps = defineProps({
  label: {
    type: String,
    default: "Zeit"
  },
  variant: {
    type: String,
    default: "outlined"
  },
  readonly: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

</script>